
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/reports",
      function () {
        return require("private-next-pages/[lang]/reports/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/reports"])
      });
    }
  